import { Pagination } from "@mui/material";
import { CalendarIcon, CheckCircledIcon, Link2Icon, PersonIcon, ReaderIcon, SewingPinFilledIcon } from "@radix-ui/react-icons";
import { useState } from "react";
import ReactDatePicker from "react-datepicker";
import { months, years } from "../../Utils/Utils";
import { Counter } from "../../components/Stats/Counter";
import { Tabs } from "../../components/Widget/Tab";
const RendezVous = () => {
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;
  const [select, setSelect] = useState('ANNEE');
  const [selectStatus, setSelectStatus] = useState('');
  const [active, setActive] = useState({ index: 0, value: 'Servey' });
  const listeIntention = [
    {
      ref: 'Ticket# 2023-CS123',
      createdAt: 'Effectué le 12/05/2024 12:10',
      name: 'Dennis Schulist',
      address: "Cocody,Palmeraie",
      type: 'Immeuble',
      status: "Intention confirmer"
    },
    {
      ref: 'Ticket# 2023-CS123',
      createdAt: 'Effectué le 02/02/2024 10:00',
      name: 'Ervin Howell',
      address: "Cocody,Palmeraie",
      type: 'Immeuble',
      status: "Intention confirmer"
    },
    {
      ref: 'Ticket# 2023-CS123',
      createdAt: 'Effectué le 12/05/2024 09:00',
      name: 'Clementine Bauch',
      address: "Cocody,Palmeraie",
      type: 'Immeuble',
      status: "Intention confirmer"
    },

  ]
  const more = () => { }

  const statusRdv = [
    {
      status: 'En attente'
    },
    {
      status: 'Realisé'
    },
    {
      status: 'Reprogrammé'
    }
  ]
  const rdv = [
    {
      "type": "Servey",
      "status": "en attente",
      "nom": "cocody riviera palmeraie",
      "reference": "25476Rtf",
      "date": "2024-05-12",
      "heure_debut": "08:00",
      "heure_fin": "10:00"
    },
    {
      "type": "Raccordement",
      "status": "Realisé",
      "nom": "cocody riviera palmeraie",
      "reference": "98765Abc",
      "date": "2024-05-14",
      "heure_debut": "14:00",
      "heure_fin": "16:00"
    },
    {
      "type": "Servey",
      "status": "Realisé",
      "nom": "cocody riviera palmeraie",
      "reference": "12345Def",
      "date": "2024-05-18",
      "heure_debut": "09:30",
      "heure_fin": "11:30"
    },
    {
      "type": "Raccordement",
      "status": "en attente",
      "nom": "cocody riviera palmeraie",
      "reference": "65432Xyz",
      "date": "2024-05-20",
      "heure_debut": "13:00",
      "heure_fin": "15:00"
    },
    {
      "type": "Servey",
      "status": "en attente",
      "nom": "cocody riviera palmeraie",
      "reference": "78910Ghi",
      "date": "2024-05-25",
      "heure_debut": "10:30",
      "heure_fin": "12:30"
    },
    {
      "type": "Raccordement",
      "status": "en attente",
      "nom": "cocody riviera palmeraie",
      "reference": "13579Jkl",
      "date": "2024-05-28",
      "heure_debut": "11:00",
      "heure_fin": "13:00"
    }
  ]

  return (
    <div className="">
      <div className="lg:flex gap-8 items-center mt-8">
        <h3 class="text-4xl font-bold">
          Rendez-vous
        </h3>
        <div className='ml-auto flex gap-x-3'>
          <select onChange={(e) => {
            setSelect(e.target.value)
          }} className="my-2 select">
            <option>
              Periode
            </option>
            <option value='MOIS' >Filtre par mois</option>
            <option value='ANNEE' selected>Filtre par années</option>
          </select>
          {
            select === 'MOIS' ? (
              <select onChange={(e) => {
              }} className="my-2 select">
                <option disabled selected>
                  mois
                </option>
                {
                  months.map((item) => (
                    <option value={item.code}>{item.name}</option>
                  ))
                }
              </select>
            ) : select === 'ANNEE' ? (
              <select onChange={(e) => {
              }} className="my-2 select ">
                <option disabled selected>
                  années
                </option>
                {
                  years.map((item) => (
                    <option value={item.name} selected={new Date().getFullYear() === Number(item.name) ? true : false}>{item.name}</option>

                  ))
                }

              </select>
            ) : (
              <ReactDatePicker
                dateFormat="dd-MM-yyyy"
                selected={startDate}
                onChange={(update) => {
                  if (update[1] != null) {
                  }
                  setDateRange(update);
                }}
                startDate={startDate}
                endDate={endDate}
                selectsRange
                className="text-xs font-normal cursor-pointer btn btn-sm hover:bg-gray-100 text-center h-8 my-2 w-52 rounded-md border border-input bg-gray-100 px-3 py-1 shadow-sm"
              />
            )
          }

        </div>
      </div>
      <div className="mt-4 grid md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 2xl:grid-cols-2 gap-3">
        <Counter color={'bg-[#d8e2fc]'} label={"Servey en attente"} count={3} text={"Rapport du mois"} />
        <Counter color={'bg-[#f9e0e1]'} label={"Racordement en attente"} count={3} text={"Rapport du mois"} />
      </div>

      <div className="bg-white rounded-md px-2 py-4 mt-3">
        <Tabs tabsData={[{ index: 0, value: "Servey" }, { index: 1, value: "Raccordement" }]} setActive={setActive} active={active} />
        <div className="mt-3 flex items-center gap-1">
          <input type="text" placeholder="Rechercher element..." className="text-xs input input-bordered px-3 w-80 h-10 text-gray-900 placeholder:text-gray-400"
          />
          <select className="select" onChange={(e) => { setSelectStatus(e.target.value) }}>
            <option disabled>
              Resultat
            </option>
            {
              statusRdv.map((item, index) => (
                <option key={index} value={item.status}>{item.status}</option>
              ))
            }
          </select>
          {
            selectStatus === 'Realisé' ? (
              <select className="select">
                <option disabled>
                  Resultat
                </option>
                <option value='OK'>OK</option>
                <option value='NonOK' selected>Non OK</option>
              </select>
            ) : null

          }

        </div>

        <div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-4 gap-2 my-4">
            {
              rdv.filter(item => item.type === active.value).map((item) => (
                <div className='relative bg-white rounded-xl border-slate-200 border shadow-sm'>
                  <div className="rounded-t-xl flex items-center gap-3 bg-orange-100 px-2 py-3">
                    <p className="text-[12px] font-semibold">Ticket N°323258-4</p>
                    {item.status === 'Realisé' ? <CheckCircledIcon className="ml-auto" /> : null}
                  </div>
                  <div className=" px-3 py-2 ">
                    <div className="my-1 flex items-center">
                      <div className="flex items-center gap-2">
                        <div className={` px-3 border  rounded-full py-1 text-xs ${item.status === 'en attente' ? 'text-orange-600' : item.status === 'en attente' ? 'text-gray-500' : 'text-green-600'}  font-semibold`}>{item.status}</div>
                        <div className={`px-3 border rounded-full py-1 text-xs flex ${item.type === "Servey" ? 'bg-cyan-500 text-white' : 'bg-slate-400 text-white'}   gap-1`}>{item.type === "Servey" ? <ReaderIcon /> : <Link2Icon />}  {item.type} </div>
                      </div>
                    </div>
                    <div className="items-center gap-2 space-y-3">
                      <h1 className="text-[14px] font-bold flex items-center"><SewingPinFilledIcon />{item.nom}</h1>
                      <div className="animate-pulse border-dashed border w-fit px-1 py-[2px] bg-red-50 text-red-800 border-red-600 rounded">
                        <p className="text-xs flex gap-1 items-center font-medium"><CalendarIcon /> rendez-vous : 25/07/2024 à 08h00</p>
                      </div>
                      {
                        item.result === 'NonOK' ? (
                          <div className="dropdown flex items-center">
                            <p className="text-xs">Plus d'info sur la cause</p>
                            <div tabIndex={0} role="button" className="btn btn-circle btn-ghost btn-xs text-info">
                              <svg tabIndex={0} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" className="w-4 h-4 stroke-current"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                            </div>
                            <div tabIndex={0} className="card compact dropdown-content z-[1] shadow bg-base-100 rounded-box w-64">
                              <div tabIndex={0} className="card-body">
                                <p>Commentaire du servey ici</p>
                              </div>
                            </div>
                          </div>
                        ) : null
                      }
                      <div className="flex gap-1 ">
                        <PersonIcon className="bg-gray-100 rounded-full w-8 h-8 p-2" />
                        <div>
                          <p className="text-[13px] font-medium">Pascal Fred</p>
                          <p className="text-xs flex font-semibold gap-2"><span>0143657821</span> {" | "} <span>0713789620</span>   </p>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              ))
            }
          </div>
        </div >
        <div className='my-3 flex justify-end'>
          <Pagination onChange={(event, newValue) => more(newValue)}
            onSelect={selectedPage => more(selectedPage)} count={listeIntention.length} variant="outlined" color='primary' shape="rounded" />
        </div>
      </div >
    </div >
  )

}

export default RendezVous